export const FoodOrderingGenAIModelSettingId = "61cc990e-f123-45c7-b953-58a1fce8f752";
export const FoodOrderingGenAIPromptOverrideSettingId = "56ef3cd9-07b7-43d9-b185-5bfb5affd092";
export const EnableDeepAnalysisSettingId = "751ac7f1-8fc0-4a4a-9e1b-c7b655884724";
